import { Formik, FormikErrors } from 'formik'
import { AddNewCustomerForm } from '../AddNewCustomerForm/AddNewCustomerForm'
import { FooterV2 } from '../../../common/components/FooterV2/FooterV2'
import { ButtonV2 } from '@labrav/react-components'
import { useStyles } from './AddNewCustomerPage.styles'
import { useDispatch, useSelector } from '../../../store'
import {
  CloudProvidersType,
  Customer,
  SubscribeProducts,
} from '../../modules/NewCustomers/reducer'
import getAdminNewCustomerValidations from '../../../common/utils/AdminNewCustomer/AdminNewCustomerValidations'
import { customerUpdatedData } from '../../../common/utils/AdminNewCustomer/customerUpdatedData'
import {
  resetForm,
  submitCustomerForm,
} from '../../modules/NewCustomers/actions'
import {
  flyoutFeatures,
  cloudfaasFeatures,
  integrationsFeatures,
  marketingFeatures,
  oppsyncFeatures,
  salsesFeatures,
  getFeatureKeysForProduct,
} from '../../../common/utils/featureList.ts'
import { useNavigate } from 'react-router-dom'
import { useFlagValue } from '@labrav/flags'

export const AddNewCustomerPage = () => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const initiaslValues = useSelector<Customer>(
    state => state.newCustomerCreation
  )
  const isAdminUiFeatureSelection =
    useFlagValue('adminUiFeatureSelection')?.value ?? false
  const noOps = () => void 0

  const handleCancel = () => {
    dispatch(resetForm())
    navigate('/oppsync/admin/partners')
  }

  const onSubmitData = async (
    data: Customer,
    errors: FormikErrors<Customer>
  ) => {
    if (Object.keys(errors).length > 0) return

    const updatedData = customerUpdatedData(data)
    const response = await dispatch(submitCustomerForm(updatedData))
    if (response?.success) {
      dispatch(resetForm())
      navigate('/oppsync/admin/partners')
    }
  }
  const initialSubscribedProducts: Partial<SubscribeProducts> = {
    FLYOUT: {
      cloudProviders: ['AWS' as CloudProvidersType],
      features: flyoutFeatures
        ?.filter(featureItem => featureItem?.key !== 'ALL')
        ?.map(flyoutFeature => flyoutFeature?.key),
    },
    OPPSYNC: {
      cloudProviders: ['AWS' as CloudProvidersType],
      features: oppsyncFeatures
        ?.filter(featureItem => featureItem?.key !== 'ALL')
        ?.map(oppsyncFeature => oppsyncFeature?.key),
    },
    CLOUDFAAS: {
      cloudProviders: ['AWS' as CloudProvidersType],
      features: cloudfaasFeatures
        ?.filter(featureItem => featureItem?.key !== 'ALL')
        ?.map(cloudfaasFeature => cloudfaasFeature?.key),
    },
    MARKETING: {
      cloudProviders: ['AWS' as CloudProvidersType],
      features: marketingFeatures
        ?.filter(featureItem => featureItem?.key !== 'ALL')
        ?.map(marketingFeature => marketingFeature?.key),
    },
    SALES: {
      features: salsesFeatures
        ?.filter(featureItem => featureItem?.key !== 'ALL')
        ?.map(salsesFeature => salsesFeature?.key),
    },
    INTEGRATIONS: {
      features: integrationsFeatures
        ?.filter(featureItem => featureItem?.key !== 'ALL')
        ?.map(integrationsFeature => integrationsFeature?.key),
    },
  }
  const adminNewCustomerValidations = getAdminNewCustomerValidations(
    isAdminUiFeatureSelection
  )
  return (
    <Formik
      initialValues={{
        ...initiaslValues,
        subscribedProducts: initialSubscribedProducts,
      }}
      validationSchema={adminNewCustomerValidations}
      onSubmit={noOps}
    >
      {formikProps => (
        <form>
          <div
            className={classes.adminRoot}
            data-testid={'create-new-customer'}
          >
            <AddNewCustomerForm formikProps={formikProps} mode="create" />
          </div>

          <FooterV2
            width="calc(100% - 60px)"
            actions={
              <div className={classes.actionsAdminFooter}>
                <div className={classes.cancelButton}>
                  <ButtonV2
                    onClick={handleCancel}
                    data-testid="cancel-btn"
                    styleType="outlined"
                  >
                    Cancel
                  </ButtonV2>
                </div>
                <div>
                  <ButtonV2
                    type="submit"
                    data-testid={'submit-invite-member'}
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.preventDefault()
                      formikProps.handleSubmit()
                      onSubmitData(formikProps.values, formikProps.errors)
                    }}
                  >
                    Submit & invite members
                  </ButtonV2>
                </div>
              </div>
            }
          />
        </form>
      )}
    </Formik>
  )
}
